<template>
  <li :class="cssClasses">
    <span class="facet-label" @click="toggleFilter">
      {{ facet.displayName }}
    </span>
    <span v-if="facet.count" class="facet-count">
      ({{ facet.count }})
    </span>
  </li>
</template>

<script>
  export default {
    props: {
      facet: { required: true, type: Object },
      isSelected: { required: true, type: Boolean }
    },
    computed: {
      cssClasses() {
        if (this.isSelected) {
          return 'individual-facet facet-selected';
        }
        return 'individual-facet';
      }
    },
    methods: {
      toggleFilter() {
        this.$emit('toggle-filter', {
          displayName: this.facet.displayName,
          filterValue: this.facet.filterValue
        });
      }
    }
  }
</script>
